import { types } from 'mobx-state-tree'

const FormFieldBase = types
  .model('FormFieldBase', {
    isDirty: types.optional(types.boolean, false),
  })
  .actions((self) => ({
    makeDirty() {
      self.isDirty = true
    },
  }))

export const FormStringFieldModel = types
  .compose(
    FormFieldBase,
    types.model('FormFieldModel', {
      value: types.optional(types.string, ''),
    })
  )
  .preProcessSnapshot((snapshot) => {
    return {
      value: snapshot,
    }
  })
  .actions((self) => ({
    postProcessSnapshot() {
      return self.value
    },
    setValue(value: string): void {
      self.value = value
      self.isDirty = true
    },
    makeDirty() {
      self.isDirty = true
    },
  }))
export type TFormStringFieldModel = typeof FormStringFieldModel.Type

export const FormBooleanFieldModel = types
  .compose(
    FormFieldBase,
    types.model('FormFieldModel', {
      value: types.optional(types.boolean, false),
    })
  )
  .preProcessSnapshot((snapshot) => {
    return {
      value: snapshot,
    }
  })
  .actions((self) => ({
    postProcessSnapshot() {
      return self.value
    },
    setValue(value: boolean): void {
      self.value = value
      self.isDirty = true
    },
    makeDirty() {
      self.isDirty = true
    },
  }))

export const FormStringFieldWithDisabledModel = types
  .compose(
    'FormStringFieldWithDisabledModel',
    FormStringFieldModel,
    types.model({ disabled: types.optional(types.boolean, false) })
  )
  .actions((self) => ({
    setDisabled(disabled: boolean): void {
      self.disabled = disabled
    },
  }))
